import { LogLevel } from "@azure/msal-browser";

// Debug environment variables
console.log('=== MSAL Configuration Debug ===');
console.log('REACT_APP_TENANT_ID:', process.env.REACT_APP_TENANT_ID);
console.log('REACT_APP_APP_CLIENT_ID:', process.env.REACT_APP_APP_CLIENT_ID); 
console.log('REACT_APP_OPENAPI_CLIENT_ID:', process.env.REACT_APP_OPENAPI_CLIENT_ID);
console.log('Current origin:', window.location.origin);

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_OPENAPI_CLIENT_ID, // SPA client ID confirmed by user
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                console.log(`[MSAL ${level}] ${message}`);
            },
            piiLoggingEnabled: false
        }
    }
};

console.log('=== MSAL Config Created ===');
console.log('Authority:', msalConfig.auth.authority);
console.log('ClientId:', msalConfig.auth.clientId);
console.log('RedirectUri:', msalConfig.auth.redirectUri);

export const loginRequest = {
    scopes: [`api://${process.env.REACT_APP_APP_CLIENT_ID}/user_impersonation`],
};

// Request for ID token with groups claim
export const idTokenRequest = {
    scopes: ['openid', 'profile', 'email'],
    // Request groups claim in the ID token
    extraQueryParameters: {
        // This requests group IDs in the token
        // Note: Azure AD may return a groups overage claim if user is in >200 groups
    }
};

console.log('=== Login Request Scopes ===');
console.log('Scopes:', loginRequest.scopes);

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphMemberOfEndpoint: "https://graph.microsoft.com/v1.0/me/memberOf",
};

// Graph API scopes for fetching group memberships (fallback when groups exceed token limit)
export const graphRequest = {
    scopes: ["User.Read", "GroupMember.Read.All"],
};